/* 布局 */
//前台
import Layout from "@views/layout";

const activityqueRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "activityque",
            name: "ACTIVITYQUE",
            meta: {
                title: "活动问题管理",
                sort: 1,
            },
            component: () => import("@views/business/activityque/index.vue"),
            redirect: {
                name: "ACTIVITYQUE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "ACTIVITYQUE_LIST",
                    meta: {
                        title: "活动问题管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/activityque/list.vue"),
                },
                                {
                    path: "add",
                    name: "ACTIVITYQUE_ADD",
                    meta: {
                        title: "新增活动问题表",
                        parentPath: '/business/activityque/list',
                        operate: true,
                    },
                    component: () => import("@views/business/activityque/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "ACTIVITYQUE_EDIT",
                    meta: {
                        title: "编辑活动问题表",
                        parentPath: '/business/activityque/list',
                        operate: true,
                    },
                    component: () => import("@views/business/activityque/form.vue"),
                },
                                        ],
    },


        ],
};

export default activityqueRouter;
